<template>
  <div class="wim-focus-section tva-row" :id="'wim-focus-preview-'+content.id">
    <div :class="['wim-focus-black-container', content.option === 'big' ? 'big tva-col-xs-offset-2 tva-col-xs-8 tva-col-sm-offset-2 tva-col-sm-7 tva-col-md-offset-1 tva-col-md-6' : 'small']">
      <div :class="['wim-focus-content', content.option === 'big' ? 'big tva-col-sm-offset-2 tva-col-sm-9' : 'small']">
        <div class="wim-focus-smallname"><h5 class="white">{{focusContent.smallText}}</h5></div>
        <div class="wim-focus-title"><h3 :class="[content.option === 'big' ? 'big' : 'small']" v-html="focusContent.title">{{focusContent.title}}</h3></div>
        <div v-if="content.option === 'big'" class="wim-focus-name"><h6 v-html="focusContent.name">{{focusContent.name}}</h6></div>
        <div class="wim-outline-shape"></div>
        <div class="wim-focus-picture" v-if="content.option === 'big'">
          <img v-lazy="`${baseUrl}images${$mq === 'mobile' ? '-mobile' : ''}/${focusContent.image}${$retina ? '@2x' : ''}.jpg`" alt="image">
        </div>
        <div :class="['wim-focus-read', content.option === 'big' ? 'big' : 'small']" @click="toggleFocus"><h5 class="red">{{focusContent.action}}</h5></div>
      </div>
    </div>
  </div>
</template>
<script>
import _ from "lodash"

export default {
  props:["content"],
  data(){
    return {
      baseUrl: process.env.BASE_URL
    }
  },
  computed: {
    focusContent(){
      return _.filter(this.$ml.get('focus'), d => d.id === this.content.id)[0]
    }
  },
  methods: {
    toggleFocus(){
      this.$router.push(`/focus/${this.content.id}/${this.$ml.current}`)
    }
  }
}

</script>
<style lang="scss" scoped>
@import "../assets/scss/colors.scss";
@import "../assets/scss/fonts.scss";
.wim-focus-section {
  width: 100%;
  .wim-focus-black-container {
    margin-top: 50px;
    margin-bottom: 50px;
    background: $black; 
    position: relative;
    &.big  {
      .wim-focus-title {
        margin-top:15%;
        z-index: 1;
        position: relative;
      }
      .wim-focus-read {
        position: absolute;
        top:45%;
        right:-40%;
        user-select: none;
      }
      .wim-focus-name {
        margin-bottom:20%;
      }
      .wim-outline-shape {
        position: absolute;
        top:10%;
        left:-5%;
        border: solid 1px $red;
        width: 150%;
        height: 60%;
        margin-top:10%;
        align-self: center;
        z-index: 1;
      }
    }
    &.small {
      .wim-focus-smallname {
        padding-top: 1px;
        margin-left:10%;
      }
      .wim-focus-title {
        text-align:right;
        margin-right: 20%;
        margin-top:15%;
      }
      .wim-focus-read {
        margin-bottom: 10%;
        margin-left:10%;
        margin-top: 10%;
        padding-bottom:1px;
      }
      .wim-outline-shape {
        position: absolute;
        bottom:-5%;
        left:-5%;
        border: solid 1px $red;
        width: 90%;
        height: 80%;
        z-index: 1;
        pointer-events: none;
      }
    }
  }
  
  .wim-focus-read {
    z-index:3;
    cursor:pointer;
    &.big::after {
      content: "";
      height: 3px;
      width: 0px;
      border-bottom: solid 1px $red;
      position:absolute;
      bottom:20px;
      left:calc(50% - 10px);
      transition: all .5s ease;
    }
    &.small::after {
      content: "";
      height: 3px;
      width: 0px;
      border-bottom: solid 1px $red;
      position:absolute;
      bottom:20px;
      left:50px;
      transition: all .5s ease;
    }
    &:hover::after {
      width: 20px;
    }
  }
  .wim-focus-picture img{
    position: absolute;
    bottom:0;
    right:5%;
    width: 35%;
  }
  
}
@media(max-width: 768px) {
  .wim-focus-section {
    padding: 0 10px;
    .wim-focus-black-container.small,
    .wim-focus-black-container.big {
      .wim-focus-picture {
        display: none;
      }
      .wim-focus-title {
        text-align: left !important;
        margin: 10%;
      }
      .wim-outline-shape {
        position: absolute;
        top: 10px;
        left: 10px;
        height: 100%;
        width: 100%;
        border: solid 2px #EF7575;
      }
      .wim-focus-name,
      .wim-focus-smallname {
        margin-left:10%;
      }
      .wim-focus-read {
        position: relative;
        text-align: left;
        right: 0 !important;
        margin-left:10%;
        color: $white;
       &::after {
         content: none;
       } 
      }
    }
  }
}
</style>